import { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";
import { Trans } from "react-i18next";

function FunnelSeries(props) {
  let myData = props?.data || [];
  const t = props?.t;

  

  useLayoutEffect(() => {
    if (!myData?.length || myData[0]?.applicants === 0) return; 
    let root = am5.Root.new("funnelChart");

    // Remove amCharts logo
    root._logo.dispose();

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.SlicedChart.new(root, {
        layout: root.horizontalLayout,
      })
    );

    // Define data
    let data = myData || [];

    // Create series
    let series = chart.series.push(
      am5percent.FunnelSeries.new(root, {
        name: "Series",
        valueField: "applicants",
        categoryField: "stage",
        orientation: "vertical",
        alignLabels: false,
        bottomRatio: 0,
        width: am5.percent(90),
        legendLabelText: "{category}:",
        legendValueText: "[bold]{value} ({percentage}%[/])",
      })
    );
    series.data.setAll(data);
    series.labels.template.setAll({
      fontSize: 15,
      text: "{category}: [bold]{value}[/]",
    });
    series.links.template.setAll({
      height: 40,
    });

    // Tooltip configuration
    let tooltip = am5.Tooltip.new(root, {
      pointerOrientation: "down", // Arrow pointing down
      labelText: "{category}: {value}",
      background: am5.RoundedRectangle.new(root, {
        fill: am5.color("#ffffff"), // Tooltip background color white
        stroke: am5.color("#fff"),
        strokeWidth: 1,
        cornerRadiusTL: 5, // Top-left corner radius
        cornerRadiusTR: 5, // Top-right corner radius
        cornerRadiusBR: 5, // Bottom-right corner radius
        cornerRadiusBL: 5, // Bottom-left corner radius
        shadowColor: am5.color("#000000"),
        shadowBlur: 8,
        shadowOffsetX: 2,
        shadowOffsetY: 2,
      }),
      autoTextColor: false, // Disable auto text color
    });

    // Ensure tooltip text is white
    tooltip.label.setAll({
      fill: am5.color("#fff"), // White text color for tooltip
    });

    // Add tooltip to slices
    series.slices.template.setAll({
      tooltipText: "{category}: {value}",
      tooltip: tooltip,
      cornerRadius: 5, // Add border radius to slices
    });

    // Add an arrow to the tooltip
    series.slices.template.events.on("over", function (ev) {
      let slice = ev.target;
      let sliceTooltip = slice.get("tooltip");

      // Create arrow pointer for the tooltip
      if (sliceTooltip) {
        sliceTooltip.setAll({
          pointerOrientation: "down", // Pointing downwards
          pointerLength: 10, // Length of the arrow
          pointerWidth: 10, // Width of the arrow base
        });
      }
    });

    series.slices.template.states.create("active", {
      shiftRadius: 0,
      stroke: am5.color(0x995522),
      strokeWidth: 10,
    });

    // Add legend
    let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        y: am5.percent(68),
        layout: root.verticalLayout,
      })
    );

    legend.data.setAll(series.dataItems);

    return () => {
      root.dispose();
    };
  }, [props?.data]);

  if (!myData?.length || myData[0]?.applicants === 0) {
    return (
      <div className="no-data data-available">
        <img src="../img/data-not-available.png" alt="data not available" />
        <h3>{t(`Dashboard.No Item Found`)}</h3>
        <p>
          <Trans>{t(`Dashboard.No Item Msg`)}</Trans>
        </p>
      </div>
    );
  }

  return (
    <div className="cards-section p-2">
      <div id="funnelChart" style={{ width: "100%", height: "500px" }}></div>
    </div>
  );
}

export default FunnelSeries;
